(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.HBKCoffeeAdvisor = api;
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var PRODUCTS = [
    {
      id: 'bio-urstark', family: 'bio-urstark', name: 'BIO Urstark', formLabel: 'Ganze Bohne',
      forms: ['beans'], brew: ['automatic', 'espresso'], intensity: 5, bio: true, decaf: false,
      tastes: ['spicy', 'nutty', 'espresso'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354353.jpg?v=1629301560',
      url: '/products/bio-urstark-ganze-kaffeebohnen-250g',
      description: 'Kräftiger Bio-Espresso mit würzigem Charakter und fein nussiger Note.'
    },
    {
      id: 'bio-crema-pur', family: 'bio-crema-pur', name: 'BIO Crema Pur', formLabel: 'Ganze Bohne',
      forms: ['beans'], brew: ['automatic', 'espresso'], intensity: 4, bio: true, decaf: false,
      tastes: ['creamy', 'soft'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354209_front.jpg?v=1603797328',
      url: '/products/bio-crema-pur-ganze-bohnen',
      description: 'Cremig, weich und vielseitig – besonders passend für Vollautomat und Milchkaffee.'
    },
    {
      id: 'bio-reinkultur', family: 'bio-reinkultur', name: 'BIO Reinkultur', formLabel: 'Gemahlen',
      forms: ['ground'], brew: ['filter'], intensity: 3, bio: true, decaf: false,
      tastes: ['mild', 'aromatic'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354219_front.jpg?v=1603806226',
      url: '/products/reinkultur-kaffeebohnen-gemahlen',
      description: 'Ein milder, aromatischer Bio-Filterkaffee für den klassischen Kaffeegenuss.'
    },
    {
      id: 'bio-sanftmut', family: 'bio-sanftmut', name: 'BIO Sanftmut', formLabel: 'Gemahlen',
      forms: ['ground'], brew: ['filter'], intensity: 1, bio: true, decaf: false,
      tastes: ['mild', 'soft'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354352_c09af643-12d5-4a2c-bc2b-6a13d2ab8403.jpg?v=1629135759',
      url: '/products/sanftmut-kaffeebohnen-gemahlen',
      description: 'Besonders sanft und leicht im Aroma – die milde Wahl in Bio-Qualität.'
    },
    {
      id: 'cafehaus-beans', family: 'cafehaus', name: 'Caféhaus', formLabel: 'Ganze Bohne',
      forms: ['beans'], brew: ['automatic', 'espresso'], intensity: 3, bio: false, decaf: false,
      tastes: ['classic', 'aromatic'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354210_front.jpg?v=1603798663',
      url: '/products/cafehaus-ganze-kaffeebohnen',
      description: 'Der traditionsreiche HAGENBECK KAFFEE-Klassiker: aromatisch, ausgewogen und mittelkräftig.'
    },
    {
      id: 'cafehaus-ground', family: 'cafehaus', name: 'Caféhaus', formLabel: 'Gemahlen',
      forms: ['ground'], brew: ['filter'], intensity: 3, bio: false, decaf: false,
      tastes: ['classic', 'aromatic'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/files/Mock_Up_Front_Cafehaus_gem_250g_RGB.jpg?v=1760562772',
      url: '/products/cafehaus-kaffeebohnen-gemahlen',
      description: 'Der traditionsreiche HAGENBECK KAFFEE-Klassiker: aromatisch, ausgewogen und mittelkräftig.'
    },
    {
      id: 'hanseat', family: 'hanseat', name: 'Hanseat', formLabel: 'Gemahlen',
      forms: ['ground'], brew: ['filter', 'manual'], intensity: 3, bio: false, decaf: false,
      tastes: ['spicy', 'aromatic'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/files/Mock_Up_Front_Hanseat_250g_RGB.jpg?v=1760562772',
      url: '/products/hanseat',
      description: 'Ein klassischer, würzig-aromatischer Kaffee für Maschine oder manuellen Kaffeebereiter.'
    },
    {
      id: 'der-milde', family: 'der-milde', name: 'Der Milde', formLabel: 'Gemahlen',
      forms: ['ground'], brew: ['filter'], intensity: 1, bio: false, decaf: false,
      tastes: ['mild', 'soft'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/files/Mock_Up_Front_DerMilde_500g_RGB.jpg?v=1760562772',
      url: '/products/der-milde-kaffeebohnen-gemahlen',
      description: 'Mild, sanft und ausgewogen – eine ruhige klassische Alternative für Filterkaffee.'
    },
    {
      id: 'blank', family: 'blank', name: 'Blank', formLabel: 'Gemahlen · entkoffeiniert',
      forms: ['ground'], brew: ['filter'], intensity: 1, bio: false, decaf: true,
      tastes: ['soft'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/files/Mock_Up_Front_Blank_250g_RGB.jpg?v=1760562772',
      url: '/products/blank-entkoffeiniert-kaffeebohnen-gemahlen',
      description: 'Entkoffeiniert, sanft und rund mit einem harmonisch weichen Charakter.'
    },
    {
      id: 'nummer-7', family: 'nummer-7', name: 'Nummer 7', formLabel: 'Ganze Bohne',
      forms: ['beans'], brew: ['espresso', 'automatic'], intensity: 5, bio: false, decaf: false,
      tastes: ['spicy', 'chocolate', 'nutty', 'espresso'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/files/Mock_Up_Front_Nummer7_250g_RGB.jpg?v=1760114058',
      url: '/products/nummer-7-ganze-kaffeebohnen',
      description: 'Ein profilierter, sehr kräftiger Espresso mit schokoladigen und nussigen Noten.'
    },
    {
      id: 'espresso-beans', family: 'espresso', name: 'Espresso', formLabel: 'Ganze Bohne',
      forms: ['beans'], brew: ['espresso', 'automatic'], intensity: 5, bio: false, decaf: false,
      tastes: ['spicy', 'chocolate', 'espresso'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354213_front.jpg?v=1603799303',
      url: '/products/espresso-ganze-kaffeebohnen',
      description: 'Der klassische kräftige Espresso: stark, würzig und leicht schokoladig.'
    },
    {
      id: 'espresso-ground', family: 'espresso', name: 'Espresso', formLabel: 'Gemahlen',
      forms: ['ground'], brew: ['espresso'], intensity: 5, bio: false, decaf: false,
      tastes: ['spicy', 'chocolate', 'espresso'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/files/Mock_Up_Front_Espresso_250g_gem_RGB.jpg?v=1760562772',
      url: '/products/espresso-kaffeebohnen-gemahlen',
      description: 'Der klassische kräftige Espresso: stark, würzig und leicht schokoladig.'
    },
    {
      id: 'schuemli', family: 'schuemli', name: 'Schümli', formLabel: 'Ganze Bohne',
      forms: ['beans'], brew: ['automatic', 'espresso'], intensity: 4, bio: false, decaf: false,
      tastes: ['creamy', 'soft'],
      image: 'https://cdn.shopify.com/s/files/1/0501/9916/7133/products/354217_front.jpg?v=1603798086',
      url: '/products/schumli-ganze-kaffeebohnen',
      description: 'Der beliebte, cremig-weiche Allrounder – schwarz genauso stimmig wie mit Milch.'
    },
    {
      id: 'entree', family: 'entree', name: 'ENTRÉE Bio-Kapseln', formLabel: 'Nespresso-kompatibel',
      forms: ['capsule'], brew: ['capsule'], intensity: null, bio: true, decaf: false,
      tastes: [],
      image: 'https://shop.hagenbeck-kaffee.de/cdn/shop/files/HKA_Pack_Cups_frontal-mit_zwei_Kapseln_RGB_2026_530x@2x.jpg?v=1789511170',
      url: '/products/entree-biokaffee-in-30-bio-aroma-kapseln',
      description: 'Runde Bio-Kaffeekapseln mit feiner Süße für Nespresso-kompatible Kapselmaschinen.'
    }
  ];

  var TASTE_GROUPS = {
    mild: ['mild', 'soft'],
    classic: ['classic', 'aromatic'],
    spicy: ['spicy'],
    creamy: ['creamy', 'soft'],
    chocolate: ['chocolate', 'nutty'],
    espresso: ['espresso']
  };

  var LABELS = {
    forms: { beans: 'ganze Bohnen', ground: 'gemahlenen Kaffee', capsule: 'Kapseln' },
    brew: { automatic: 'den Vollautomaten', espresso: 'den Siebträger', filter: 'die Filtermaschine', manual: 'die manuelle Zubereitung', capsule: 'die Kapselmaschine' },
    intensity: { mild: 'mild', medium: 'ausgewogen', strong: 'kräftig', very: 'sehr kräftig' },
    taste: { mild: 'sanft', classic: 'klassisch-aromatisch', spicy: 'würzig', creamy: 'cremig-weich', chocolate: 'schokoladig-nussig', espresso: 'espresso-typisch' }
  };

  function scoreProduct(product, answers) {
    var score = 0;
    var reasons = [];

    if (answers.decaf === true && !product.decaf) return null;
    if (answers.decaf !== true && product.decaf) score -= 35;
    if (answers.brew === 'capsule' && product.id !== 'entree') return null;
    if (answers.form === 'capsule' && product.id !== 'entree') return null;
    if (product.id === 'entree' && answers.form && answers.form !== 'any' && answers.form !== 'capsule') return null;
    if (answers.bio === 'yes' && !product.bio) return null;
    if (answers.bio === 'no' && product.bio) return null;
    if (answers.form && answers.form !== 'any' && product.forms.indexOf(answers.form) === -1) return null;

    if (answers.form && answers.form !== 'any' && product.forms.indexOf(answers.form) !== -1) {
      score += 40;
      reasons.push('passt zur gewünschten Produktform');
    }

    if (answers.brew && answers.brew !== 'any' && product.brew.indexOf(answers.brew) !== -1) {
      score += 35;
      reasons.push('eignet sich für ' + LABELS.brew[answers.brew]);
    }

    if (answers.bio === 'yes' && product.bio) {
      score += 25;
      reasons.push('ist Bio-zertifiziert');
    }

    if (answers.intensity && answers.intensity !== 'any' && product.intensity !== null) {
      var targets = { mild: [1, 2], medium: [3], strong: [4], very: [5] }[answers.intensity];
      var distance = Math.min.apply(null, targets.map(function (target) { return Math.abs(product.intensity - target); }));
      if (distance === 0) {
        score += 25;
        reasons.push('trifft die gewünschte Intensität');
      } else if (distance === 1) {
        score += 10;
      }
    }

    if (answers.taste && answers.taste !== 'any') {
      var matches = TASTE_GROUPS[answers.taste].some(function (taste) { return product.tastes.indexOf(taste) !== -1; });
      if (matches) {
        score += 20;
        reasons.push('passt zur Geschmacksrichtung „' + LABELS.taste[answers.taste] + '“');
      }
    }

    if (product.id === 'schuemli' && answers.bio !== 'yes') {
      if (answers.brew === 'automatic' || answers.brew === 'any') score += 12;
      if (answers.taste === 'creamy' || answers.taste === 'any') score += 8;
      if (answers.form === 'any') score += 4;
    }

    if (product.id === 'bio-crema-pur' && answers.bio === 'yes') {
      if (answers.brew === 'automatic') score += 10;
      if (answers.taste === 'creamy') score += 12;
    }

    if (product.id === 'nummer-7' && answers.intensity === 'very' && answers.brew === 'espresso' && answers.taste === 'chocolate') score += 18;
    if (product.id === 'bio-urstark' && answers.bio === 'yes' && answers.intensity === 'very' && (answers.brew === 'espresso' || answers.brew === 'automatic') && answers.taste === 'spicy') score += 18;
    if (product.family === 'cafehaus' && answers.taste === 'classic') score += 12;
    if (product.id === 'hanseat' && answers.taste === 'spicy') score += 12;
    if (product.id === 'bio-sanftmut' && answers.bio === 'yes' && answers.intensity === 'mild') score += 14;
    if (product.id === 'der-milde' && answers.bio !== 'yes' && answers.intensity === 'mild') score += 14;

    if (answers.decaf === true && product.decaf) {
      score += 200;
      reasons = ['ist entkoffeiniert'];
    }

    return { product: product, score: score, reasons: reasons };
  }

  function recommend(answers, limit) {
    var seenFamilies = {};
    var specificAnswerCount = ['form', 'brew', 'intensity', 'bio', 'taste'].filter(function (key) {
      return answers && answers[key] && answers[key] !== 'any';
    }).length;
    var rankedResults = PRODUCTS
      .map(function (product) { return scoreProduct(product, answers || {}); })
      .filter(Boolean)
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.product.name.localeCompare(b.product.name, 'de');
      })
      .filter(function (entry) {
        if (seenFamilies[entry.product.family]) return false;
        seenFamilies[entry.product.family] = true;
        return true;
      });
    var relevantResults = rankedResults.filter(function (entry) {
      return specificAnswerCount < 3 || entry.reasons.length >= 2;
    });
    var results = relevantResults.length ? relevantResults : rankedResults.slice(0, 1);

    return results.slice(0, limit || 3);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function reasonText(entry, answers) {
    if (answers.decaf) return 'Du suchst Kaffee ohne Koffein. Blank ist die entkoffeinierte Sorte im HAGENBECK KAFFEE-Sortiment.';
    if (entry.product.id === 'entree') return 'Du nutzt eine Kapselmaschine. ENTRÉE ist der passende, Nespresso-kompatible Kapselkaffee im Sortiment.';
    if (entry.product.family === 'espresso' && answers.form === 'ground' && answers.brew === 'manual' && answers.intensity === 'very' && answers.taste === 'espresso') {
      return 'Dein Wunschprofil ist sehr kräftig und espresso-typisch – deshalb steht Espresso vorn. Für French Press ist Hanseat die passendere Alternative zur Zubereitung.';
    }

    var lead = entry.reasons.slice(0, 2).join(' und ');
    if (!lead) lead = 'passt insgesamt gut zu deinen Angaben';
    return 'Dieser Kaffee ' + lead + '. ' + entry.product.description;
  }

  function mountAdvisor(container) {
    var steps = Array.prototype.slice.call(container.querySelectorAll('[data-advisor-step]'));
    var progress = container.querySelector('[data-advisor-progress]');
    var progressText = container.querySelector('[data-advisor-progress-text]');
    var results = container.querySelector('[data-advisor-results]');
    var resultGrid = container.querySelector('[data-advisor-result-grid]');
    var card = container.querySelector('[data-advisor-card]');
    var answers = {};
    var currentStep = -1;

    function showStep(index) {
      currentStep = index;
      card.hidden = false;
      container.classList.add('is-active');
      results.hidden = true;
      steps.forEach(function (step, stepIndex) { step.hidden = stepIndex !== index; });
      if (index === 1) {
        var capsuleBrewOption = steps[index].querySelector('[data-advisor-key="brew"][data-advisor-value="capsule"]');
        if (capsuleBrewOption) capsuleBrewOption.hidden = answers.form !== 'any';
      }
      progress.closest('.hbk-advisor__progress-wrap').hidden = false;
      progress.style.width = (((index + 1) / steps.length) * 100) + '%';
      progressText.textContent = 'Frage ' + (index + 1) + ' von ' + steps.length;
      var heading = steps[index].querySelector('h3');
      if (heading) heading.focus({ preventScroll: true });
    }

    function renderResults() {
      var recommendations = recommend(answers, 3);
      steps.forEach(function (step) { step.hidden = true; });
      card.hidden = false;
      container.classList.add('is-active');
      results.hidden = false;
      progress.closest('.hbk-advisor__progress-wrap').hidden = true;
      resultGrid.innerHTML = recommendations.map(function (entry, index) {
        var product = entry.product;
        return '<article class="hbk-advisor__result-card' + (index === 0 ? ' is-top' : '') + '">' +
          '<div class="hbk-advisor__result-image"><img src="' + escapeHtml(product.image) + '" alt="Packung ' + escapeHtml(product.name) + '" loading="lazy" width="420" height="420"></div>' +
          '<div class="hbk-advisor__result-copy">' +
            (index === 0 ? '<p class="hbk-advisor__match">Unsere Empfehlung</p>' : '<p class="hbk-advisor__match">Passt ebenfalls</p>') +
            '<h4>' + escapeHtml(product.name) + '</h4>' +
            '<p class="hbk-advisor__form">' + escapeHtml(product.formLabel) + '</p>' +
            '<p>' + escapeHtml(reasonText(entry, answers)) + '</p>' +
            '<a class="hbk-advisor__product-link" href="' + escapeHtml(product.url) + '">Produkt ansehen</a>' +
          '</div>' +
        '</article>';
      }).join('');
      var heading = results.querySelector('h3');
      if (heading) heading.focus({ preventScroll: true });
    }

    function reset() {
      answers = {};
      currentStep = -1;
      steps.forEach(function (step) { step.hidden = true; });
      results.hidden = true;
      card.hidden = true;
      container.classList.remove('is-active');
      progress.closest('.hbk-advisor__progress-wrap').hidden = true;
      container.querySelector('[data-advisor-begin]').focus({ preventScroll: true });
    }

    container.querySelector('[data-advisor-begin]').addEventListener('click', function () { showStep(0); });

    container.addEventListener('click', function (event) {
      var option = event.target.closest('[data-advisor-option]');
      if (option && container.contains(option)) {
        if (option.dataset.advisorDecaf === 'true') {
          answers = { decaf: true };
          renderResults();
          return;
        }
        answers[option.dataset.advisorKey] = option.dataset.advisorValue;
        if ((option.dataset.advisorKey === 'form' || option.dataset.advisorKey === 'brew') && option.dataset.advisorValue === 'capsule') {
          renderResults();
          return;
        }
        if (currentStep < steps.length - 1) showStep(currentStep + 1);
        else renderResults();
        return;
      }

      var back = event.target.closest('[data-advisor-back]');
      if (back && container.contains(back)) {
        if (currentStep > 0) showStep(currentStep - 1);
        else reset();
        return;
      }

      var restart = event.target.closest('[data-advisor-restart]');
      if (restart && container.contains(restart)) reset();
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) reset();
    });
  }

  function init() {
    document.querySelectorAll('[data-hbk-coffee-advisor]').forEach(function (container) {
      if (container.dataset.advisorReady === 'true') return;
      container.dataset.advisorReady = 'true';
      mountAdvisor(container);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  }

  return { PRODUCTS: PRODUCTS, scoreProduct: scoreProduct, recommend: recommend };
});
